import React, { useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import HahnIcon from "../../svgs/digital-H-icon.svg"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

const PredictiveData = () => {
  useEffect(() => {
    if (typeof window !== `undefined`) {
      gsap.registerPlugin(ScrollTrigger)
      gsap.core.globals("ScrollTrigger", ScrollTrigger)
    }

    ScrollTrigger.matchMedia({
      "(min-width: 1201px)": function () {
        //title animation

        let tlOne = gsap.timeline({
          paused: true,
          scrollTrigger: {
            trigger: "#section_two_animate",
            start: "top 90%",
            end: "top 90%",
            id: "section_two_title",
            toggleActions: "play play reverse reverse",
          },
        })
        tlOne.to(".ai-header", { duration: 0.1, opacity: "1" })
        tlOne.to(".ai-header", {
          maxHeight: "210px",
          maxWidth: "930px",
          padding: "50px 55px",
          border: "10px solid #C44C4A",
        })
        tlOne.to(".ai-logo-box", {
          duration: 0.3,
          opacity: "1",
          left: "-200px",
        })

        // Fade in content

        let tlAiOne = gsap.timeline({
          paused: true,
          scrollTrigger: {
            trigger: "#section_two_content",
            start: "top 90%",
            end: "top 90%",
            id: "section_two_content",
            toggleActions: "play play reverse reverse",
          },
        })
        tlAiOne.to(
          ".ai-content",
          { duration: 0.5, opacity: "1", top: "0px" },
          0.5
        )
        tlAiOne.to(".stwo-map", { duration: 0.5, opacity: "1", top: "0px" }, 1)
      },
      "(max-width: 1200px)": function () {
        let aiMobileOne = gsap.timeline({
          paused: true,
          scrollTrigger: {
            trigger: "#ai_mobile_one",
            start: "top 90%",
            end: "top 90%",
            id: "ai_mobile_one",
            toggleActions: "play play reverse reverse",
          },
        })
        aiMobileOne.to(".ai-header", { duration: 0.5, opacity: "1", top: "0" })

        let aiMobileThree = gsap.timeline({
          paused: true,
          scrollTrigger: {
            trigger: "#ai_mobile_three",
            start: "top 90%",
            end: "top 90%",
            id: "ai_mobile_three",
            toggleActions: "play play reverse reverse",
          },
        })
        aiMobileThree.to(
          ".ai-content",
          { duration: 0.5, opacity: "1", top: "0" },
          0.5
        )
        aiMobileThree.to(
          ".stwo-map",
          { duration: 0.5, opacity: "1", top: "0" },
          1
        )
      },
    })
  }, [])

  const data = useStaticQuery(graphql`
    query {
      dataDashboardImage: file(relativePath: { eq: "data-dashboard.png" }) {
        childImageSharp {
          gatsbyImageData(
            width: 700
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)

  return (
    <MainSection id="section_two_animate">
      <div class="top-row">
        <div class="ai-animation-block" id="ai_mobile_one">
          <div class="ai-header">
            <h2>Our Differentiator?</h2>
          </div>
          <div class="ai-logo-box">
            <div class="hahn-icon">
              <HahnIcon />
            </div>
          </div>
        </div>
      </div>
      <div class="main-row" id="section_two_content">
        <div class="left-col">
          <GatsbyImage
            className={"stwo-map"}
            image={data.dataDashboardImage.childImageSharp.gatsbyImageData}
            alt={"Hahn.Agency Predictive Data Science"}
          />
        </div>
        <div class="right-col">
          <div class="ai-content" id="ai_mobile_three">
            <h3>Predictive Data Science</h3>
            <p>We use it to help clients ranging from food producers to energy providers see patterns, discover trends, imagine creative possibilities, and Wow! audiences of all shapes and sizes.</p>
          </div>
        </div>
      </div>
    </MainSection>
  )
}

const MainSection = styled.section`
  max-width: 1310px;
  width: 100%;
  margin: 100px auto;
  padding: 0 20px;
  position: relative;
  .top-row {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0px;
    padding-right: 70px;
    .ai-animation-block {
      height: 210px;
      position: relative;
    }
    .ai-header {
      border: 25px solid #c44c4a;
      padding: 0;
      max-height: 0;
      max-width: 0;
      overflow: hidden;
      opacity: 0;
      position: relative;
      h2 {
        font-family: "Nobel", sans-serif;
        font-size: 70px;
        line-height: 1.1;
        font-weight: 700;
        color: #2b2520;
        margin-top: 0;
        margin-bottom: 0px;
        margin-right: 230px;
        width: 558px;
      }
      p {
        font-family: "Work Sans";
        font-size: 36px;
        line-height: 50px;
        font-weight: 400;
        color: #777c7c;
        margin-top: 0;
        margin-bottom: 0;
        max-width: 600px;
      }
    }
    .ai-logo-box {
      position: absolute;
      top: 0px;
      left: -180px;
      width: 200px;
      height: 200px;
      opacity: 0;
      img {
        position: absolute;
        top: 0;
        right: 0;
      }
      .hahn-icon {
        position: absolute;
        width: 200px;
        height: 200px;
        right: 0;
        top: 0;
      }
    }
  }
  .main-row {
    width: 100%;
    margin-top: 100px;
    padding-left: 70px;
    display: flex;
    .left-col {
      width: 700px;
      .stwo-map {
        opacity: 0;
        top: 20px;
        position: relative;
      }
    }
    .right-col {
      width: 416px;
      padding-left: 55px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end;
      .ai-icon {
        margin-top: 60px;
        margin-bottom: 40px;
        width: 209px;
        height: 209px;
        position: relative;
        top: 20px;
        opacity: 0;
      }
      .ai-content {
        width: 100%;
        position: relative;
        top: 20px;
        opacity: 0;
        h3 {
          font-family: "Work Sans";
          font-size: 30px;
          line-height: 36px;
          font-weight: 800;
          color: #2b2520;
          margin-top: 140px;
          margin-bottom: 10px;
        }
        p {
          font-family: "Work Sans";
          font-size: 24px;
          line-height: 2;
          font-weight: 400;
          color: #777c7c;
          margin-top: 0;
          margin-bottom: 0px;
          max-width: 560px;
        }
        a {
          font-family: "Work Sans";
          font-size: 20px;
          line-height: 24px;
          font-weight: 700;
          color: #2b2520;
          margin-top: 10px;
          margin-bottom: 10px;
          text-decoration: none;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          transition-duration: 0.3s;
          svg {
            width: 24px;
            margin-left: 10px;
            transition: all 0.3s cubic-bezier(0.77, 0, 0.175, 1);
          }
          &:hover {
            color: #c44c4a !important;
            svg {
              transform: translateX(10px);
            }
          }
        }
      }
    }
  }
  @media (max-width: 1200px) {
    .top-row {
      padding-right: 0px;
      .ai-header {
        border: 10px solid #c44c4a !important;
        padding: 35px !important;
        max-height: 100% !important;
        max-width: 100% !important;
        overflow: hidden;
        top: 40px;
        h2 {
          font-size: 70px;
          line-height: 1.2;
          margin-bottom: 0px;
        }
        p {
          font-size: 28px;
          line-height: 1.2;
        }
      }
    }
  }
  @media (max-width: 1000px) {
    flex-wrap: wrap;
    max-width: 700px;
    .top-row {
      justify-content: center;
      margin-bottom: 60px;
      .ai-animation-block {
        height: auto;
        width: 100%;
      }
      .ai-header {
        width: 100%;
        h2 {
          font-size: 44px;
        }
        p {
          font-size: 20px;
        }
      }
    }
    .main-row {
      padding-left: 0;
      flex-wrap: wrap;
      margin-top: 60px;
      .left-col {
        order: 2;
        width: 100%;
        max-width: 520px;
        width: 100%;
        margin: 0 auto;
      }
      .right-col {
        order: 1;
        width: 100%;
        padding-left: 0;
        .ai-icon {
          display: none;
        }
        .ai-content {
          max-width: 520px;
          margin: 0 auto;
          margin-bottom: 40px;
        }
      }
    }
  }
  @media (max-width: 767px) {
    max-width: 500px;
    width: 100%;
    overflow: hidden;
    margin: 50px auto;
    .top-row {
      margin-bottom: 0;
      .ai-header {
        padding: 20px !important;
        border: 5px solid #c44c4a !important;
        h2 {
          font-size: 32px;
          width: 100%;
        }
      }
    }
    .main-row {
      margin-top: 0px;
      .right-col {
        .ai-content {
          margin-top: 40px;
          h3 {
            font-size: 24px;
            line-height: 1.2;
            margin-top: 20px;
          }
          p {
            font-size: 16px;
            line-height: 1.6;
          }
          a {
            font-size: 18px;
          }
        }
      }
      .left-col {
        .chat-box-outer {
          max-width: 470px;
          width: 100%;
          height: 410px;
          .ai-chat-box {
            max-width: 470px;
            width: 100%;
            height: 400px;
            .chat-message-window {
              height: 278px;
            }
          }
        }
      }
    }
  }
`

export default PredictiveData
